export default {
  contractActivity: {
    contractActivity: {
      title: ({ plural }) => plural(["Activité", "Activités"]),
      type: {
        professional: "Entreprise",
        pedagogic: "Formation",
      },
      tabs: {
        description: "Description",
        document: "Annexes",
      },
      status: {
        complete: "Complète",
        to_complete: "À compléter",
      },
      context: "Contexte",
      description: "Tâches réalisées",
      difficulties_encountered: "Difficultés & solutions",
      results_obtained: "Résultats obtenus",
      analysis_and_learning: "Analyse & apprentissage",
      tools: "Outils & technologies",
      skills: "Compétences liées",
      autonomy_complexity: "Autonomie & complexité",
      missions: "Missions liées",
      no_activities: "Aucune activité n'est définie sur ce contrat.",
      no_activities_filtered: "Aucune activité ne correspond au filtre sélectionné.",
      relatedSkills: {
        launch_analysis: "Lancer l'analyse",
        relaunch_analysis: "Relancer l'analyse",
        badge_default: "Analyse IA des compétences",
        badge_with_date: ({ named }) => `Référentiel ${named("code")} — Analyse effectuée le ${named("date")}`,
        badge_no_date: ({ named }) => `Référentiel ${named("code")}`,
        no_activity_id: "Enregistrez d'abord l'activité pour accéder aux compétences.",
        no_analysis: "Cliquez sur « Lancer l'analyse » pour identifier les compétences mobilisées dans cette activité.",
        analysing: "Analyse en cours, veuillez patienter…",
        ai_analysis: "Analyse IA de correspondance entre l'activité et le bloc de compétence",
        summary_title: "Analyse IA de correspondance de l'activité avec les compétences",
        validated: "Validé",
        to_validate: "À valider",
        validate_all_proposals: "Valider la relation activité/compétences",
        add_block_picker_title: "Ajouter manuellement des blocs de compétences",
        add_block_confirm: "Ajouter les blocs sélectionnés",
        selected_skills_count: ({ named }) =>
          `${named("count")} compétence${named("count") <= 1 ? "" : "s"} sélectionnée${named("count") <= 1 ? "" : "s"}`,
        collapsed_selected_skills_heading: "Compétences sélectionnées",
        skill_status_selected: "Compétence sélectionnée",
        skill_status_validated: "Compétence validée",
      },
      annexes: {
        count: ({ named }) => `${named("count")} annexe(s) jointe(s) à cette activité`,
        technical_documents: "Documents techniques",
        screenshots_photos: "Captures d'écran & photos",
        empty: "Aucune annexe jointe à cette activité.",
      },
    },
  },
};
